import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';

export const MuiTableTheme = (mode: PaletteMode): Components<Theme>['MuiTable'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        fontFamily: typographyTokens.fontFamilies.sans,
        color: componentTokens.table.colors.text.row.secondary,
        // Make a new "stacking context" so that any absolute- / sticky-positioned
        // items (like header rows) will not pollute the global z-index space.
        position: 'relative',
        zIndex: 0,
      },
    },
  };
};

export const MuiTableCellTheme = (mode: PaletteMode): Components<Theme>['MuiTableCell'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        fontSize: typographyTokens.fontSizes.sm,
        borderBottom: 'none', // Override MUI default
        color: componentTokens.table.colors.text.row.secondary,
        padding: 8,
        verticalAlign: 'middle',
        // Make nested Typography components (including Text) inherit font size
        '& .MuiTypography-root': {
          fontSize: 'inherit',
        },
      },
    },
  };
};

export const MuiTableHeadTheme = (mode: PaletteMode): Components<Theme>['MuiTableHead'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        // Default header styling
        '& .MuiTableCell-root': {
          color: componentTokens.table.colors.text.header.resting,
          textTransform: 'uppercase',
          fontSize: typographyTokens.fontSizes.xs,
          lineHeight: typographyTokens.lineHeights.xs,
          fontWeight: typographyTokens.fontWeights.semibold,
          letterSpacing: 'normal',
          textAlign: 'left',
        },
      },
    },
  };
};

export const MuiTableRowTheme = (mode: PaletteMode): Components<Theme>['MuiTableRow'] => {
  const { componentTokens } = themePalette(mode);

  return {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${componentTokens.table.colors.stroke.divider.base}`,
        transition: 'all 0.05s linear',
      },
    },
  };
};
